export const BvidsNoImages = ["c00965db-7b3e-4435-b336-db1b1d15a56d"]
